// extracted by mini-css-extract-plugin
module.exports = {"postsContainer":"FunFacts_postsContainer__ndNf0"};